module.exports = __webpack_public_path__ + "img/etageav.4154fee2.png";